import { render, staticRenderFns } from "./_CertificateReceiveItem.vue?vue&type=template&id=20931f36&"
import script from "./_CertificateReceiveItem.vue?vue&type=script&lang=js&"
export * from "./_CertificateReceiveItem.vue?vue&type=script&lang=js&"
import style0 from "./_CertificateReceiveItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports